export const DEFAULT_TO_ALL: undefined = undefined;
export const LIVE_SIDEBAR_NAV_MAIN_MARKETS: number = 1;
export const DEFAULT_LIVE_SIDEBAR_GROUPS_EXPANDED: number = Infinity;
